import * as Sentry from "@sentry/react";
import { CLIENT_BASE_URL, SERVER_BASE_URL } from "./env.jsx";

const getRegexUrl = (url) => {
  return new RegExp(url.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).source;
}

const { SWIVU_SENTRY_KEY, SWIVU_ENV } = import.meta.env;

Sentry.setTag("app_type", "Client");
Sentry.init({
  dsn: SWIVU_SENTRY_KEY,
  enabled: Boolean(SWIVU_SENTRY_KEY),
  environment: SWIVU_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      networkCaptureBodies: true, // this will only work for the fetch api type of requests and we have currently configured axios, but still I want to keep this enabled
      networkDetailAllowUrls: [getRegexUrl(SERVER_BASE_URL)],
    }),
    Sentry.httpClientIntegration(),
    Sentry.reportingObserverIntegration({
      types: ["crash", "intervention"]
    }),
    // See doc to enable router monitoring https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/#react-router-v4v5
    // Sentry.reactRouterV5BrowserTracingIntegration(),
  ],
  // Tracing
  tracesSampleRate: 0.1, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // To enable localhost errors tracking just add localhost:300
  tracePropagationTargets: [getRegexUrl(CLIENT_BASE_URL), getRegexUrl(SERVER_BASE_URL)],
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 0.1,
  // Session Replay
  replaysSessionSampleRate: 0.5, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  normalizeDepth: 10, // this will allow us to expand json nested object to max 10 levels
  sendDefaultPii: true,
  beforeSend(event) {
    if (window.swivuSocketTransactionQueue?.length) {
      event.extra = {
        ...(event.extra || {}),
        socketReceivedTransactions: [...window.swivuSocketTransactionQueue]
      }
    }

    return event;
  }
});

export const addUserInfoSentry = (user) => {
  Sentry.setUser({
    id: user.id,
    username: `${user.first_name} ${user.last_name}`.trim(),
    email: user.email,
  });
}

/**
 *
 * @param {string} messageTitle
 * @param {Sentry.SeverityLevel} logType
 * @param {any} extraDataBody
 */
export const sendCustomMessageOnSentry = ({
  messageTitle, logType, extraDataBody
}) => {
  Sentry.captureMessage(messageTitle, {
    level: logType,
    extra: extraDataBody
  })
}
